import script from "./CustomTooltip.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomTooltip.vue?vue&type=script&setup=true&lang=ts"

import "./CustomTooltip.vue?vue&type=style&index=0&id=47af24ff&lang=scss"

const __exports__ = script;

export default __exports__